export const weatherData = {
  location: "London",
  temperature: "18°",
  condition: "Partly Cloudy",
  high: "21°",
  low: "14°",
  wind: "12 km/h",
  humidity: "64%",
  forecast: [
    { day: "Today", icon: "cloud_queue", summary: "20% Rain", high: "21°", low: "14°" },
    { day: "Tue", icon: "wb_sunny", summary: "Sunny", high: "24°", low: "16°" },
    { day: "Wed", icon: "thunderstorm", summary: "Stormy", high: "19°", low: "12°" }
  ],
  forecast7: [
    { day: "Today", icon: "cloud_queue", summary: "20% Rain", high: "21°", low: "14°" },
    { day: "Tue", icon: "wb_sunny", summary: "Sunny", high: "24°", low: "16°" },
    { day: "Wed", icon: "thunderstorm", summary: "Stormy", high: "19°", low: "12°" },
    { day: "Thu", icon: "partly_cloudy_day", summary: "Partly Cloudy", high: "22°", low: "15°" },
    { day: "Fri", icon: "rainy", summary: "Rain", high: "17°", low: "10°" },
    { day: "Sat", icon: "foggy", summary: "Foggy", high: "16°", low: "9°" },
    { day: "Sun", icon: "wb_sunny", summary: "Sunny", high: "18°", low: "11°" }
  ],
  hourly3h: [
    { timeLabel: "00:00", icon: "partly_cloudy_night", summary: "Partly Cloudy", temp: "16°" },
    { timeLabel: "03:00", icon: "cloud_queue", summary: "Light Rain", temp: "15°" },
    { timeLabel: "06:00", icon: "rainy", summary: "Rain", temp: "14°" },
    { timeLabel: "09:00", icon: "thunderstorm", summary: "Stormy", temp: "16°" },
    { timeLabel: "12:00", icon: "wb_sunny", summary: "Sunny", temp: "18°" },
    { timeLabel: "15:00", icon: "partly_cloudy_day", summary: "Partly Cloudy", temp: "19°" },
    { timeLabel: "18:00", icon: "cloud_queue", summary: "20% Rain", temp: "17°" },
    { timeLabel: "21:00", icon: "foggy", summary: "Foggy", temp: "16°" }
  ]
};

export const tubeStatusData = {
  updatedAt: "Just now",
  lines: [
    {
      name: "Central Line",
      details: "Minor delays between Leytonstone and Epping due to a signal failure.",
      status: "Minor Delays",
      state: "alert"
    },
    {
      name: "Jubilee Line",
      details: "No reported issues.",
      status: "Good Service",
      state: "good"
    },
    {
      name: "Victoria Line",
      details: "Operating normally.",
      status: "Good Service",
      state: "good"
    }
  ]
};

export const transactionsData = {
  totalAvailable: "£9,300.80",
  trend: "+2.4%",
  items: [
    {
      merchant: "Apple Store",
      meta: "Electronics • June 12",
      amount: "-£999.00",
      positive: false,
      icon: "shopping_bag"
    },
    {
      merchant: "Monthly Salary",
      meta: "Deposit • June 10",
      amount: "+£2,050.00",
      positive: true,
      icon: "payments"
    },
    {
      merchant: "The Steakhouse",
      meta: "Dining • June 08",
      amount: "-£124.50",
      positive: false,
      icon: "restaurant"
    },
    {
      merchant: "Gas Station",
      meta: "Transport • June 05",
      amount: "-£65.00",
      positive: false,
      icon: "directions_car"
    },
    {
      merchant: "Tesco",
      meta: "Groceries • June 04",
      amount: "-£238.40",
      positive: false,
      icon: "local_grocery_store"
    },
    {
      merchant: "Local Cafe",
      meta: "Coffee • June 03",
      amount: "-£12.75",
      positive: false,
      icon: "local_cafe"
    },
    {
      merchant: "Streaming Plus",
      meta: "Subscription • June 02",
      amount: "-£9.99",
      positive: false,
      icon: "subscriptions"
    },
    {
      merchant: "Bus Travel",
      meta: "Transport • June 01",
      amount: "-£54.20",
      positive: false,
      icon: "directions_bus"
    },
    {
      merchant: "Pension Credit",
      meta: "Deposit • May 31",
      amount: "+£850.00",
      positive: true,
      icon: "payments"
    },
    {
      merchant: "Energy Bill",
      meta: "Utilities • May 28",
      amount: "-£132.10",
      positive: false,
      icon: "lightbulb"
    }
  ]
};
